import { Controller } from "stimulus"
import Rails from '@rails/ujs';

export default class extends Controller {
  initialize() {
    if (this.element.nodeName !== 'FORM') console.error('This controller should be attached to a form.')
    this.onChange = this._handleChange.bind(this)
  }

  connect() {
    let controls = this.element.querySelectorAll('select, input[type="checkbox"], input[type="radio"]')
    controls.forEach((control) => control.addEventListener('change', this.onChange))
  }

  disconnect() {
    let controls = this.element.querySelectorAll('select, input[type="checkbox"], input[type="radio"]')
    controls.forEach((control) => control.removeEventListener('change', this.onChange))
  }

  _handleChange() {
    if (typeof Rails === 'undefined') console.error('Rails is not present, we should import it now!')
    Rails.fire(this.element, 'submit')
  }
}
